import { environment } from "src/environments/environment";

const LEGACY_USER_IMAGES_PATTERN =
  /timitimsorg[^/]*\/(?:v1\/)?UserImages\/(.+)$/i;

/** Resolve stored profile picture values to a loadable URL (or empty string). */
export function resolveProfilePicUrl(raw?: string | null): string {
  if (raw == null) {
    return "";
  }

  const trimmed = String(raw).trim();
  if (!trimmed) {
    return "";
  }

  const legacyMatch = trimmed.match(LEGACY_USER_IMAGES_PATTERN);
  if (legacyMatch) {
    const fileName = legacyMatch[1].replace(/^@+/, "").replace(/^\/+/, "");
    return fileName ? `${environment.imageStorageBaseUrl}${fileName}` : "";
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  const fileName = trimmed.replace(/^@+/, "").replace(/^\/+/, "");
  return fileName ? `${environment.imageStorageBaseUrl}${fileName}` : "";
}

/** Normalize profilePicUrl on a user-like object in place. */
export function normalizeUserProfilePic<T extends { profilePicUrl?: string | null }>(
  user: T | null | undefined
): T | null | undefined {
  if (!user) {
    return user;
  }
  const resolved = resolveProfilePicUrl(user.profilePicUrl);
  user.profilePicUrl = resolved || null;
  return user;
}
